import React from 'react'

import { cn } from '@/shared/lib/utils'

export type InputProps = {
	invalid?: boolean
	disabled?: boolean
} & React.ComponentProps<'input'>
export type TextfieldProps = {
	variant?: 'outline' | 'filled'
	iconBefore?: React.ReactNode
	iconAfter?: React.ReactNode
	addonBefore?: React.ReactNode
	addonAfter?: React.ReactNode
} & InputProps

const Textfield = ({
	disabled,
	invalid,
	variant = 'outline',
	addonBefore,
	addonAfter,
	iconBefore,
	iconAfter,
	className,
	...otherProps
}: TextfieldProps) => (
	<div
		className={cn(
			'flex h-8 w-auto items-center gap-1 rounded-lg border border-input bg-input/20 px-2 text-sm focus-within:border focus-within:border-solid dark:bg-input/30',
			'focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/30',
			{
				'border-accent bg-tertiary focus-within:bg-tertiary hover:border':
					variant === 'filled',
				'border-destructive ring-[3px] ring-destructive/20 focus-within:border-destructive focus-within:ring-destructive/20':
					invalid,
				'cursor-not-allowed border opacity-50 hover:cursor-not-allowed':
					disabled,
			},
			className
		)}
	>
		{!!addonBefore && (
			<span className='text-muted-foreground'>{addonBefore}</span>
		)}
		{!!iconBefore && (
			<span className='inline-flex items-center text-muted-foreground'>
				{iconBefore}
			</span>
		)}
		<input
			className='flex h-full w-full shrink-0 grow basis-0 self-stretch border-none bg-transparent px-1 outline-hidden placeholder:text-sm placeholder:text-placeholder disabled:cursor-not-allowed'
			disabled={disabled}
			{...otherProps}
		/>
		{!!iconAfter && (
			<span
				className={cn(
					'inline-flex items-center',
					invalid ? 'text-destructive' : 'text-muted-foreground'
				)}
			>
				{iconAfter}
			</span>
		)}
		{!!addonAfter && (
			<span className='text-muted-foreground'>{addonAfter}</span>
		)}
	</div>
)

export { Textfield }
